//////////// CSS /////////////
import './styles.css';
import logo_gcmpta from '../../assets/image/gcmptalogo_bgnone.png';

//////////// REACT /////////////
import React from 'react';
import { useHistory } from "react-router-dom";

//////////// REDUX | STORE | SERVICE /////////////
import { useDispatch } from 'react-redux';
import { signin } from '../../store/slice/authentication';
import { setCookie } from '../../store/cookie';
import { HttpRequest } from '../../service/HttpRequest';


function Login() {

    const dispatch = useDispatch();
    const history = useHistory();

    const [formControl, setFormControl] = React.useState({
        username: "",
        password: ""
    });

    // React.useEffect(() => {
    //    console.log(formControl);
    // }, [formControl]);

    const handleSubmit = async e => {
        e.preventDefault();

        // console.log(formControl);
        // /admin/checksession
        HttpRequest("/admin/login", formControl).then(data => {
            console.log(data);
            if (data.result === "OK") {
                onSignin(data)
            } else {
                alert(data.errormessage);
            }

        });
    }

    const onSignin = (dataLogin) => {

        dispatch(signin({ token: dataLogin.session.sessiontoken, user: dataLogin.user }));
        setCookie("authen", true, 1);
        setCookie("token", dataLogin.session.sessiontoken, 1);

        history.replace("/d-rec-admin/main");

    }

    return <div className="main-content" style={{ background: "#f9fde1", paddingTop: "200px" }}>
        <form className='form-login-content' onSubmit={handleSubmit}>
            <img src={logo_gcmpta} className='img_logo' alt="Logo" />
            <p>Welcome to D-REC-ADMIN.</p>
            {/* <p>You not Authentication. Please click button below.</p> */}
            <p>Please login.</p>
            <input className="custom-input" type="text" style={{width: "inherit", textAlign: "center"}}
                placeholder="username"
                onChange={(e) => { setFormControl(state => ({ ...state, username: e.target.value })); }} />
            <input className="custom-input" type="password" style={{width: "inherit", textAlign: "center"}}
                placeholder="password"
                onChange={(e) => { setFormControl(state => ({ ...state, password: e.target.value })); }} />
                
            <button className='bt-login' type='submit' style={{minHeight: 44}}>Login</button>
            {/* <button className='bt-login' type='submit'>SAML<br />AUTHENTICATION</button> */}
        </form>
    </div>;
}

export default Login;